import { useState } from 'react'
import { IconButton, TableCell, TableRow } from '@mui/material'
import { DeleteIcon } from 'components/Icons'
import { EditIcon } from 'components/Icons'
import Confirm from 'components/Dialog'
import { useDispatch } from 'react-redux'
import { destroy } from 'store/settings/grade-level-section'
import { Link as NavLink } from 'react-router-dom'
import { useBasePath } from 'components/Providers'
import { useTranslation } from 'react-i18next'

export default function GradeSectionItem({ gradeSection, hasReadWritePermission }) {
  const [confirm, setConfirm] = useState(false)
  const dispatch = useDispatch()
  const basePath = useBasePath()
  const { t } = useTranslation()

  const onConfirm = () => {
    setConfirm(false)
    dispatch(destroy({ id: gradeSection.id }))
  }

  return (
    <TableRow hover>
      <TableCell>
        {gradeSection.gradeSection}
      </TableCell>
      <TableCell>{gradeSection.gradeLevel.name}</TableCell>
      <TableCell> {gradeSection.seat}</TableCell>
      <TableCell> </TableCell>
      {hasReadWritePermission && (
        <TableCell align="left" sx={{ pl: 0 }}>
          <IconButton component={NavLink} to={`${basePath}/${gradeSection.id}`} aria-label={t('edit')}>
            <EditIcon />
          </IconButton>
          <IconButton
            aria-label={t('delete')}
            onClick={() => {
              setConfirm(true)
            }}
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      )}
      <Confirm open={confirm} onClose={() => setConfirm(false)} onConfirm={onConfirm} />
    </TableRow>
  )
}
